import React from 'react';
import { Row, Col } from '../GridSystem';

const PostItemPlaceholder = () => (
    <div className="blog-item item-loading">
        <div className="blog-item__meta">
            <div className="placeholder-block" style={{ width: '30px' }} />
            <div className="placeholder-block" style={{ width: '50px' }} />
        </div>

        <div className="blog-item__inner">
            <Row>
                <Col xs={12} md={12} lg={4}>
                    <div className="placeholder-block" style={{ width: '60%' }} />
                    <div className="placeholder-block" style={{ width: '80%' }} />
                    <div className="placeholder-block" style={{ width: '30%' }} />
                </Col>

                <Col xs={12} md={12} lg={8}>
                    <div className="blog-item__excerpt">
                        <div className="placeholder-block placeholder-block--inline" style={{ width: '30%' }} />
                        <div className="placeholder-block placeholder-block--inline" style={{ width: '40%' }} />
                        <div className="placeholder-block placeholder-block--inline" style={{ width: '10%' }} />

                        <div className="placeholder-block placeholder-block--inline" style={{ width: '10%' }} />
                        <div className="placeholder-block placeholder-block--inline" style={{ width: '20%' }} />
                        <div className="placeholder-block placeholder-block--inline" style={{ width: '30%' }} />
                        <div className="placeholder-block placeholder-block--inline" style={{ width: '10%' }} />

                        <div className="placeholder-block placeholder-block--inline" style={{ width: '50%' }} />
                        <div className="placeholder-block placeholder-block--inline" style={{ width: '10%' }} />
                        <div className="placeholder-block placeholder-block--inline" style={{ width: '15%' }} />
                    </div>
                </Col>
            </Row>
        </div>

        <div className="highlight" />
    </div>
);

export default PostItemPlaceholder;



// WEBPACK FOOTER //
// ./src/components/PostItemPlaceholder/index.js